<template>
  <div class="experiment ma-0 p-3">
    <v-card>
      <v-row v-if="current.user_level=='INCHARGE' || current.user_level=='ADMIN'">
        <v-col class="d-flex justify-start">
          <v-btn class="ml-auto mr-3" color='green lighten-4' @click="dialog = !dialog">
            <v-icon left> mdi-plus </v-icon>
            {{ $t("manage.by_school.announcement.school_announcement.btn.add_announcement") }}
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        dense
        :locale="localeTranslate()"
        :headers="tableHeader()" 
        :items="api.school_announcements" 
        item-key="id"
        :items-per-page="-1">
        <template v-slot:[`item.priority`]="{ item }"> 
          <v-badge class="mr-3" :color="priority_color[item.priority]" inline dot></v-badge>
          <span v-if="$i18n.locale=='tc'">{{ priority_name_chi[item.priority] }}</span>
          <span v-else>{{ priority_name[item.priority] }}</span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">        
          <v-tooltip top color="primary">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="openEditDialog(item)">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("manage.by_school.announcement.school_announcement.btn.edit") }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialog" persistent max-width="700px" >
      <v-card class="pb-3">
        <v-toolbar dark color="green">
          <v-btn icon dark @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("manage.by_school.announcement.school_announcement.add.header") }}</v-toolbar-title>
        </v-toolbar>
        <v-row justify="center" no-gutters>
          <v-col cols="11"  class="my-2 px-1">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  dense
                  v-model="form.school_id"
                  :label="editItemLabel('school_label')"
                  readonly
                  disabled
                ></v-text-field>
              </v-col>              
              <v-col cols="12">
                <v-select
                  :items="priority"
                  :item-text="editItemLabel('priority')"
                  item-value="priority"
                  v-model="form.priority"
                  :label="editItemLabel('priority_label')"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  :label="editItemLabel('value_en_label')"
                  v-model="form.value_en"
                  auto-grow
                  rows="1"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  :label="editItemLabel('value_ch_label')"
                  v-model="form.value_ch"
                  auto-grow
                  rows="1"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.end_date"
                      :label="editItemLabel('end_date_label')"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    :locale="localeTranslate()"
                    v-model="form.end_date"
                    color="green lighten-2"
                    no-title
                    @input="menu = false"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-btn class="mr-3" color="primary" @click="addSchoolAnnouncement">
              {{ $t("manage.by_school.announcement.school_announcement.add.btn.add") }}
            </v-btn>
            <v-btn class="mr-3" @click="1">
              {{ $t("manage.by_school.announcement.school_announcement.add.btn.discard") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editDialog" persistent max-width="700px" >
      <v-card class="pb-3">
        <v-toolbar dark color="green">
          <v-btn icon dark @click="closeEditDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("manage.by_school.announcement.school_announcement.edit.header") }}</v-toolbar-title>
        </v-toolbar>
        <v-row justify="center" no-gutters>
          <v-col cols="11"  class="my-2 px-1">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  dense
                  v-model="form.school_id"
                  :label="editItemLabel('school_label')"
                  readonly
                  disabled
                ></v-text-field>
              </v-col>              
              <v-col cols="12">
                <v-select
                  :items="priority"
                  :item-text="editItemLabel('priority')"
                  item-value="priority"
                  v-model="form.priority"
                  :label="editItemLabel('priority_label')"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  :label="editItemLabel('value_en_label')"
                  v-model="form.value_en"
                  auto-grow
                  rows="1"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  :label="editItemLabel('value_ch_label')"
                  v-model="form.value_ch"
                  auto-grow
                  rows="1"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.end_date"
                      :label="editItemLabel('end_date_label')"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    :locale="localeTranslate()"
                    v-model="form.end_date"
                    color="green lighten-2"
                    no-title
                    @input="menu2 = false"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-btn class="mr-3" color="primary" @click="applySchoolAnnouncementChange">
              {{ $t("manage.by_school.announcement.school_announcement.edit.btn.apply") }}
            </v-btn>
            <v-btn class="mr-3" @click="1">
              {{ $t("manage.by_school.announcement.school_announcement.edit.btn.reset") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import { api_management } from "@/services/iot/api_management";
const apiManagement = new api_management(process.env.VUE_APP_BASE_URL);


export default {
  name: "experiment",
  components: {
  },
  mixins: [],
  data: function () {
    return {
      pdfSource: 'http://180.188.140.248/remotelab/files/documents/manual/POLYU-INTERFERENCE-set_4.pdf',      
      menu: false,
      menu2: false,
      school_id: "",
      role: null,
      drawer: true,
      mini: true,
      dialog: false,
      editDialog: false,
      current:{
        school_id: null,
        username: null,
        user_level: "USER",
        auth_token: null,
      },
      user: [{
        name: null,
        level: null,
      }],
      form: {
        school_id: "",
        priority: "",
        value_en: "",
        value_ch: "",
        end_date: "",
        ref: "",
      },
      api:{
        schools:[],
        school_announcements: [],
      },
      headers: [
        { text: 'Type', value: 'type', align: ' d-none' },
        { text: 'Importance', value: 'priority' },
        { text: 'Content (English)', value: 'value_en' },
        { text: 'Content (Chinese)', value: 'value_ch' },
        { text: 'Create at', value: 'create_at' },
        { text: 'End at', value: 'end_date' },
        { text: 'Create by', value: 'create_by' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      headers_chi: [
        { text: '類別', value: 'type', align: ' d-none' },
        { text: '重要程度', value: 'priority' },
        { text: '內容(英文)', value: 'value_en' },
        { text: '內容(中文)', value: 'value_ch' },
        { text: '建立於', value: 'create_at' },
        { text: '結束於', value: 'end_date' },
        { text: '建立者', value: 'create_by' },
        { text: '操作', value: 'actions', sortable: false },
      ],
      priority: [
        { priority: "4", text: 'Crucial', text_chi: '非常重要' },
        { priority: "3", text: 'Important', text_chi: '重要' },
        { priority: "2", text: 'Normal', text_chi: '一般' },
        { priority: "1", text: 'Low', text_chi: '不重要' },
      ],
      priority_color: [null, 'light-green lighten-2', 'amber accent-2', 'orange accent-3', 'red darken-3'] ,
			priority_name: [null, 'Low', 'Normal', 'Important', 'Crucial'],
			priority_name_chi: [null, '不重要', '一般', '重要', '非常重要'],
    };
  },
  mounted: function () {
    var self = this;
    self.current.school_id = self.$route.params.school_id;
    self.current.username = self.$store.state.user.username;
    self.current.user_level = self.$store.state.user.user_level;
    self.current.auth_token = self.$store.state.user.auth_token;
    
    self.api.schools = [self.current.school_id];

    self.school_id = self.$route.params.school_id;
    self.form.school_id = self.school_id;
    self.getSchoolAnnouncementManagement(self.school_id);    
  },
  methods: {
    localeTranslate(){
      var self = this;
      if(self.$i18n.locale=='tc') return 'zh-tw';
      else return 'en';
    },
    getSchoolAnnouncementManagement(school_id){
      var self = this;      
      apiManagement.getSchoolAnnouncementManagement(school_id)
      .then((response) => {
        if(response.status=="fail"){}
        else if(response.status=="success"){
          self.api.school_announcements = response.school_announcements;
        }
      });
    },
    editItemLabel(label){
      var self = this;
      if(self.$i18n.locale=='tc') {
        if (label=='school_label') return self.$t("manage.by_school.announcement.school_announcement.edit.school");
        else if (label=='priority_label') return self.$t("manage.by_school.announcement.school_announcement.edit.priority");
        else if (label=='priority') return "text_chi";
        else if (label=='value_en_label') return self.$t("manage.by_school.announcement.school_announcement.edit.value_en");
        else if (label=='value_ch_label') return self.$t("manage.by_school.announcement.school_announcement.edit.value_ch");
        else if (label=='end_date_label') return self.$t("manage.by_school.announcement.school_announcement.edit.end_date");
      }
      else {
        if (label=='school_label') return self.$t("manage.by_school.announcement.school_announcement.edit.school");
        else if (label=='priority_label') return self.$t("manage.by_school.announcement.school_announcement.edit.priority");
        else if (label=='priority') return "text";
        else if (label=='value_en_label') return self.$t("manage.by_school.announcement.school_announcement.edit.value_en");
        else if (label=='value_ch_label') return self.$t("manage.by_school.announcement.school_announcement.edit.value_ch");
        else if (label=='end_date_label') return self.$t("manage.by_school.announcement.school_announcement.edit.end_date");
      }
    },
    tableHeader(){
      var self = this;
      if(self.$i18n.locale=='tc')
        return self.headers_chi;
      else
        return self.headers;
    },
    closeDialog(){
      var self = this;
      self.dialog = !self.dialog;
      self.form.priority = "";
      self.form.value_en = "";
      self.form.value_ch = "";
      self.form.end_date = "";
    },
    openEditDialog(item){
      var self = this;
      self.editDialog = !self.editDialog;
      self.form.school_id = item.school_id;
      self.form.priority = item.priority;
      self.form.value_en = item.value_en;
      self.form.value_ch = item.value_ch;
      self.form.end_date = item.end_date;
      self.form.ref = item.ref;
    },
    closeEditDialog(){
      var self = this;
      self.editDialog = !self.editDialog;
      self.form.priority = "";
      self.form.value_en = "";
      self.form.value_ch = "";
      self.form.end_date = "";
      self.form.ref = "";
    },
    addSchoolAnnouncement(){
      var self = this;
      apiManagement.addSchoolAnnouncement(
        self.form.school_id,
        self.form.priority,
        self.form.value_en,
        self.form.value_ch,
        self.form.end_date,
        self.current.username,
        self.current.auth_token
      )
      .then((response) => {
        if(response.status == "success"){
          self.$store.commit("showSnackBar", "Added announcement.");
          self.closeDialog();
          self.getSchoolAnnouncementManagement(self.school_id);
          //self.dialog = !self.dialog;
          //self.getSchoolExperiment();
        }
        else {
          alert(response.message);
        }
      });
    },
    applySchoolAnnouncementChange(){
      var self = this;
      apiManagement.applySchoolAnnouncementChange(
        self.form.school_id,
        self.form.priority,
        self.form.value_en,
        self.form.value_ch,
        self.form.end_date,
        self.form.ref
      )
      .then((response) => {
        if(response.status == "success"){
          self.$store.commit("showSnackBar", "Updated announcement.");
          self.closeEditDialog();
          self.getSchoolAnnouncementManagement(self.school_id);
          //self.dialog = !self.dialog;
          //self.getSchoolExperiment();
        }
        else {
          alert(response.message);
        }
      });
    },
  },
  destroyed(){
    console.log("destroyed");
  } 
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}
</style>